import { useRef } from "react";
import { CalendarDays } from "lucide-react";

/** DD/MM/YYYY for people, ISO for machines. */
export const fmtDate = (iso) => {
  if (!iso || typeof iso !== "string") return "";
  const [y, m, d] = iso.slice(0, 10).split("-");
  return y && m && d ? `${d}/${m}/${y}` : iso;
};

export const DateField = ({ value, onChange, min, max, testid, className = "" }) => {
  const native = useRef(null);
  const open = () => {
    if (native.current?.showPicker) native.current.showPicker();
    else native.current?.focus();
  };
  return (
    <div className={`field flex items-center justify-between gap-2 cursor-pointer relative ${className}`}
         onClick={open} data-testid={testid ? `${testid}-wrap` : undefined}>
      <span className={`tabular ${value ? "text-charcoal" : "text-muted"}`} data-testid={testid ? `${testid}-display` : undefined}>
        {value ? fmtDate(value) : "DD/MM/YYYY"}
      </span>
      <CalendarDays size={15} className="text-brass shrink-0" />
      <input
        ref={native}
        type="date"
        data-testid={testid}
        value={value || ""}
        min={min}
        max={max}
        onChange={(e) => onChange(e.target.value)}
        className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
        aria-label="Date"
      />
    </div>
  );
};

export default DateField;
